module.exports = __webpack_public_path__ + "static/media/photos-corners.84d5818e.jpg";